import { useMapPanelContext } from './MapPanelContext';
import { CENTERCOMPONENTS } from './CenterComponents';
import { ACTIVETAB, RIGHTSIDECOMPONENTS } from './RightSideComponents';
import { useResetDrawingContext } from '@ais-ui/react-openlayers';
import { useReportContext } from '../../Reports/ReportContext';
import { useCallback } from 'react';

export const useOnMapPanelExit = () => {
  const {
    setActiveTab,
    setRightSideComponent,
    centerComponent,
    setCenterComponent,
    setCenterComponentData,
    setTableExpanded,
  } = useMapPanelContext();

  const { resetReportContext } = useReportContext();

  const resetDrawingContext = useResetDrawingContext();

  const onExit = useCallback(() => {
    setCenterComponentData(null);
    if (
      centerComponent === CENTERCOMPONENTS.SHIPTABLE ||
      centerComponent === CENTERCOMPONENTS.ROUTES
    ) {
      setCenterComponent(CENTERCOMPONENTS.NONE);
    }

    setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
    setActiveTab(ACTIVETAB.NONE);
    resetDrawingContext();
    setTableExpanded(true);
    resetReportContext();
  }, [
    setCenterComponentData,
    setCenterComponent,
    setRightSideComponent,
    setActiveTab,
    resetDrawingContext,
    setTableExpanded,
    resetReportContext,
  ]);

  return onExit;
};
